import { Badge } from '@zoopla-eng/zds-components/badges';
import { Listing } from './listing.type';

export const getBadges = (listing: Listing) => {
    const badges: React.ReactNode[] = [];

    listing.tags?.forEach((tag) => {
        if (tag?.content) {
            if (tag.content !== 'New home') {
                badges.push(<Badge text={tag.content} level={4} />);
            }
        }
    });

    return badges;
};
